import * as React from 'react';
import { Container } from '@mui/material';
import { PropsWithChildren, useEffect } from 'react';
import Loader from 'shared/components/loader';
import useAuth from 'features/auth/hooks/use-auth';

const RootLayout: React.FC<PropsWithChildren> = (props) => {
  const { state, checkAuth } = useAuth();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  if (state.checkingAuth) {
    return <Loader />;
  }
  return (
    <Container
      maxWidth={false}
      sx={{
        height: '100vh',
        width: '100%',
        padding: '0 !important',
        overflow: 'hidden',
      }}
    >
      {props.children}
    </Container>
  );
};

export default RootLayout;
